import { Link } from 'react-router-dom';

export default function CompareHero() {
  return (
    <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-teal-900 text-white py-24 overflow-hidden">
      <div className="absolute inset-0 bg-black/20"></div>
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: `url("https://public.readdy.ai/ai/img_res/794952159aeaaf8ad74ce04578cccf1e.jpg")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 bg-amber-500/20 border border-amber-400/40 rounded-full px-4 py-2 mb-6">
            <i className="ri-scales-3-line text-amber-400"></i>
            <span className="text-sm font-semibold text-amber-300 uppercase tracking-wide">The Honest Comparison</span>
          </div>

          <h1 className="text-5xl md:text-6xl font-extrabold mb-4 leading-tight">
            Yes, We're Cheaper.<br />
            <span className="text-teal-400">No, We Didn't Forget Any Fees.</span>
          </h1>

          <p className="text-xl md:text-2xl text-slate-300 mb-3 leading-relaxed">
            A lot of car-buying costs come from fees that get added late in the process. We publish ours upfront.
            <br />
            <span className="text-amber-300 font-semibold">One flat fee. Everything else disclosed before you commit.</span>
          </p>

          <p className="text-lg text-slate-400 mb-4 max-w-2xl mx-auto">
            No back-and-forth on price. No last-minute surprises at signing. No "this deal expires tonight" — just a straightforward number you can plan around.
          </p>

          <p className="text-base text-slate-500 italic mb-10 max-w-xl mx-auto">
            Just wholesale pricing, transparent fees, and someone negotiating <em className="text-slate-300 not-italic font-semibold">for</em> you instead of <em className="text-slate-300 not-italic font-semibold">at</em> you.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="#pricing-comparison"
              className="inline-flex items-center justify-center gap-2 bg-teal-500 hover:bg-teal-400 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-money-dollar-circle-line"></i>
              Show Me the Real Numbers
            </a>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border-2 border-white/30 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-message-3-line"></i>
              Talk to a Human (We Have Those)
            </Link>
          </div>

          {/* Micro-clarity strip */}
          <div className="mt-12 flex flex-wrap justify-center gap-6 text-sm text-slate-400">
            {[
              { icon: 'ri-close-circle-line', text: 'No "market adjustment" fee' },
              { icon: 'ri-close-circle-line', text: 'No nitrogen tire upsell' },
              { icon: 'ri-close-circle-line', text: 'No surprise charges at signing' },
              { icon: 'ri-close-circle-line', text: 'No 4-hour back-and-forth on price' },
            ].map((item) => (
              <span key={item.text} className="flex items-center gap-1.5">
                <i className={`${item.icon} text-red-400`}></i>
                {item.text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}